import { Theme, Themes } from 'blockly/core';

/** Skyrover IDE Blockly theme — Zelos renderer, teal Arduino blocks */
export function createBlocklyTheme(_isDark: boolean): Theme {
  return Theme.defineTheme('skyrover', {
    name: 'skyrover',
    base: Themes.Zelos,
    blockStyles: {
      arduino_hat_blocks: {
        colourPrimary: '#20B2AA',
        colourSecondary: '#1A9690',
        colourTertiary: '#147B76',
        hat: 'cap',
      },
      arduino_blocks: {
        colourPrimary: '#20B2AA',
        colourSecondary: '#1A9690',
        colourTertiary: '#147B76',
      },
      arduino_io_blocks: {
        colourPrimary: '#5C81A6',
        colourSecondary: '#4F7193',
        colourTertiary: '#426180',
      },
      arduino_serial_blocks: {
        colourPrimary: '#CF8B17',
        colourSecondary: '#B87A14',
        colourTertiary: '#A26911',
      },
      beginner_hat_blocks: {
        colourPrimary: '#FFBF00',
        colourSecondary: '#E6AC00',
        colourTertiary: '#CC9900',
        hat: 'cap',
      },
      beginner_blocks: {
        colourPrimary: '#FFBF00',
        colourSecondary: '#E6AC00',
        colourTertiary: '#CC9900',
      },
      beginner_led_blocks: {
        colourPrimary: '#FF7043',
        colourSecondary: '#E6643C',
        colourTertiary: '#CC5835',
      },
      beginner_switch_blocks: {
        colourPrimary: '#9966FF',
        colourSecondary: '#885CE6',
        colourTertiary: '#7752CC',
      },
      beginner_sound_blocks: {
        colourPrimary: '#8BA832',
        colourSecondary: '#7A972D',
        colourTertiary: '#698628',
      },
      beginner_time_blocks: {
        colourPrimary: '#990099',
        colourSecondary: '#8A008A',
        colourTertiary: '#7A007A',
      },
      beginner_display_blocks: {
        colourPrimary: '#4285F4',
        colourSecondary: '#3B78DC',
        colourTertiary: '#346BC4',
      },
      beginner_serial_blocks: {
        colourPrimary: '#CF8B17',
        colourSecondary: '#B87A14',
        colourTertiary: '#A26911',
      },
    },
    componentStyles: {
      workspaceBackgroundColour: '#FFFFFF',
      toolboxBackgroundColour: '#ECECEC',
      toolboxForegroundColour: '#333333',
      flyoutBackgroundColour: '#F5F5F5',
      flyoutForegroundColour: '#333333',
      flyoutOpacity: 0.98,
      scrollbarColour: '#CCCCCC',
      insertionMarkerColour: '#990099',
      insertionMarkerOpacity: 0.4,
      scrollbarOpacity: 0.5,
    },
    fontStyle: {
      family: 'Inter, "Helvetica Neue", Helvetica, sans-serif',
      weight: '500',
      size: 12,
    },
  });
}
